import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const emceeAppRoute: InvariantJiraRoute = {
	name: 'global-settings-addons-emcee',
	path: '/plugins/servlet/ac/com.atlassian.jira.emcee:environment(.?[\\w.]*)?/:page',
};
